import { handleAnonId } from './storage'
import { eraseAjsLocalStorage, setAjsLocalStorageByCompanyId } from './analytics-storage'
import { integrations, validScriptIntegrations } from './tracking/integrations'

let loaded = false

export const isLoaded = () => loaded

const loadAnalytics = (companyId, callback) => {
  if (process.env.preventSegment) {
    callback()
    return
  }
  eraseAjsLocalStorage()
  setAjsLocalStorageByCompanyId(companyId)

  window.analytics.load = function (t, e) {
    const script = document.createElement('script')
    script.type = 'text/javascript'
    script.async = true
    script.src = process.env.ANALYTICS_URL
    const firstElement = document.getElementsByTagName('script')[0]
    firstElement.parentNode.insertBefore(script, firstElement)
    window.analytics._loadOptions = e

    script.onload = function () {
      callback()
    }
  }
  window.analytics.SNIPPET_VERSION = '4.1.0'
  window.analytics.load()
}

const loadAnalyticsWrapper = (companyId, config) => {
  if (isLoaded()) {
    return
  }

  const duplicate = JSON.parse(JSON.stringify(config))

  Object.keys(duplicate).forEach((displayName) => {
    if (validScriptIntegrations.indexOf(displayName) === -1) {
      delete duplicate[displayName]
    }
  })

  loaded = true

  // setTimeout(() => {
  loadAnalytics(companyId, () => {
    handleAnonId(companyId)

    // removes call by reference bindings
    if (window.analytics && window.analytics.initialize) {
      window.analytics.initialize(duplicate)

      // Loop through the interim analytics queue and reapply the calls to their
      // proper analytics.js method.
      while (window.analytics_queue.length > 0) {
        const item = window.analytics_queue.shift()
        const method = item.shift()
        if (window.analytics[method]) {
          window.analytics[method].apply(window.analytics, item)
        }
      }
    }
  })
  // }, 500)
}

export { loadAnalyticsWrapper as loadAnalytics }
